import { regions, ui, collectionEvents, events, initialize, onShow, onInitIsotope, collectionChange, checkMosaicLoadMore, waitForLoadMoreRequest, infiniteLoadMore } from 'mosaic_v2/mosaic_v2_layout_view';
import { onRender, onInitMosaicCalculations, resizeHeader, showLoadMore, hideLoadMore } from 'mosaic_v2/mosaic_v2_composite_view';

Pixlee.module('MosaicV2App.Show', function(Show, App, Backbone, Marionette, $) {
    Show.Layout = App.Views.Layout.extend({
        template: require('./templates/layout.jst.ejs'),
        tagName: 'section',
        regions,
        ui,
        collectionEvents,
        events,

        initialize: function() {
            window.counter = 0;
            initialize.call(this, App.displayOptions);
        },

        onShow,
        onInitIsotope,
        collectionChange,
        checkMosaicLoadMore,
        infiniteLoadMore: function() { infiniteLoadMore.call(this, App) },
        waitForLoadMoreRequest: function() { waitForLoadMoreRequest.call(this, window) },

        loadMore: function() {
            var loadMore = this.checkMosaicLoadMore();
            if (loadMore) {
                this.ui.loadMore.addClass('loading');
                this.collection.nextPage({
                    success: function() {
                        this.ui.loadMore.removeClass('loading');
                        this.newPhotoIndex = this.$el.find('.img_holder').length;
                        this.grid.one('layoutComplete', this.focusFirstNewPhoto.bind(this));
                        App.commands.execute('load:more', this.collection.pluck('album_photo_id'));
                        loadMore = this.checkMosaicLoadMore();
                        if (!loadMore) {
                            this.ui.loadMore.hide();
                        }
                    }.bind(this)
                });
            }
        },

        focusFirstNewPhoto: function() {
            // get newest photo element using index
            var nextPhoto = this.grid.isotope('getFilteredItemElements')[this.newPhotoIndex].firstChild;
            nextPhoto.focus({ preventScroll: true });
        }
    });
    Show.Layout.include(['LayoutHelpers', 'AccessibilityHelpers']);


    Show.PhotoView = App.Views.ItemView.extend({
        className: 'photo_block',
        tagName: 'li',
        behaviors: {
            Reviews: {},
            Share: {},
            Vote: {},
            Lightbox: {},
            UpdateThumbnailCss: {}
        },
        modelEvents: {
            'voted': 'onVotePhoto'
        },
        getTemplate: function() {
            var elementSize = this.model.get('elementSize');
            // If the widget is infinite load, photo sizes are completely random
            if (this.options.isInfiniteLoad) {
                if (_.random(0, 1)) {
                    elementSize = 'large';
                } else {
                    elementSize = 'small';
                }
                this.model.set('elementSize', elementSize);
            }
            var isLargeTemplate = _.contains(['xl', 'original'], this.options.photoQuality) && this.options.model.get('content_type') === 'image';
            if (isLargeTemplate && elementSize === 'large') {
                return require('../../common/templates/v2/_xl_photo_item.jst.ejs');
            } else {
                return require('../../common/templates/v2/_photo_item.jst.ejs');
            }
        },
        onShow: function() {
            this.triggerMethod('watch:top:change');
            this.triggerMethod('set:element:size:class');
        },
        onWatchTopChange: function() {
            var collection = this.model.collection;
            var index = collection.indexOf(this.model);
            var absoluteIndex = index - this.options.initialLength;
            var animationOffset = absoluteIndex > 0 ? (absoluteIndex * 50) : 0;
            var _this = this;
            this.$el.watch({
                properties: 'top,left',
                callback: function(data, i) {
                    setTimeout(function() {
                        if (_this.isIE()) {
                            $(this).addClass('IE_fix');
                        } else {
                            $(this).addClass('fade_in_js');
                        }
                        // run only once - delay to ensure ops have run aren't reset
                        setTimeout(function() {
                            $(this).unwatch(data.id);
                        }.bind(this), 10);
                    }.bind(this), 500 + animationOffset);
                }
            });
        },
        onSetElementSizeClass: function() {
            this.$el.addClass(this.model.get('elementSize'));
        },
        onVotePhoto: function() {
            this.$el.find('.vote_button').addClass('active');
        },
        isIE: function() {
            return (navigator.userAgent.indexOf('MSIE') !== -1) || (!!window.MSInputMethodContext && !!document.documentMode);
        },
        templateHelpers: {
            decodeUtf8: function(string) {
                return App.request('decode:utf8', string);
            }
        }
    });
    Show.PhotoView.include(['PhotoViewHelpers', 'ReviewHelpers']);

    Show.MosaicCollection = App.Views.CompositeView.extend({
        template: require('./templates/_collection_view.jst.ejs'),
        childViewContainer: '#item_container',
        childView: Show.PhotoView,
        childViewOptions: function() {
            return {
                initialLength: this.initialLength || 0,
                isInfiniteLoad: gon.display_options && gon.display_options.infiniteLoadMore,
                photoQuality: gon.display_options && gon.display_options.photoQuality || 'default'
            };
        },
        behaviors: function() {
            var behaviorHash = {
                CollectionVote: {}
            };

            // for backwards compatibility with widgets that are already out in the wild
            if (!_.isFalsy(this.options.displayOptions.headerOptions)) {
                behaviorHash.AppendUploaderTiles = {};
                if (this.options.displayOptions.headerOptions.layout === 'tile') {
                    behaviorHash.Upload = {};
                }
            }
            return behaviorHash;

        },
        initialize: function(options) {
            this.collection.reviewSelectionOptions = {
                currentModelIndex: 0
            };

            //if this isn't infinite load, we wanna run the mosaic calc
            this.runMosaicCalculation = !(gon.display_options && gon.display_options.infiniteLoadMore);
            this.collectionHasSynced = false;

            gon.fresh_images = [];
            this.initialLength = 0;
            this.collectionQueue = options.collectionQueue;
            this.triggerMethod('init:mosaic:calculations');
        },
        onShow: function() {
            //if the sync hasn't returned yet we wanna run the calc
            if (this.runMosaicCalculation && this.collectionHasSynced) {
                this.triggerMethod('calculate:perfect:mosaic');
            }
            var calculationBlock = $('#calculation_block');
            this.maxOuterPhotoWidth = calculationBlock.outerWidth(true) || 0;
            this.calculationBlockWidth = calculationBlock[0].getBoundingClientRect().width || 0;
            this.maxPhotoWidth = calculationBlock.outerWidth() || 0;
            calculationBlock.remove();
            $(window).resize(resizeHeader.bind(this));
            $('#widget').attr('alt', App.altText);
            this.runMosaicCalculation = true; //so load more can work
        },
        onCalculatePerfectMosaic: function() {
            // Calculation Constants
            var itemContainerWidth = $('#item_container').width();
            // Grab smallPhotoWidth from the max photo width of a small element or default it if 0
            var smallPhotoWidth = (this.calculationBlockWidth > 0) ? this.calculationBlockWidth : 190;
            // Initial Calculation
            var TotalSmallGridWidth = Math.floor(itemContainerWidth / smallPhotoWidth);

            // Call behavior file 'perfectMosaicHelpers' to kick off calculations
            this.calculatePhotoSizes(TotalSmallGridWidth);
        },

        onRender,
        onInitMosaicCalculations,
        showLoadMore,
        hideLoadMore
    });
    Show.MosaicCollection.include(['tabindexHelpers', 'headerHelpers', 'perfectMosaicHelpers', 'designEditorCollectionHelpers', 'socialShareHelpers']);


    Show.HeaderView = App.Views.ItemView.extend({
        template: require('../../common/templates/v2/_header.jst.ejs'),
        id: 'widget_header',
        behaviors: {
            Upload: {},
            ShowPdpCaption: {}
        }
    });
    Show.HeaderView.include(['StandaloneHeaderHelpers']);
});
